import React from "react";
import { User } from "~/common/Store/models/User";
import { CustomerExclusivity } from "~/common/Store/models/ProductListing";
import useIsMounted from "~/common/useIsMounted";
import canCustomerPurchase from "../canCustomerPurchase";
interface Props {
  user: User;
  customerExclusivity: CustomerExclusivity;
}
const CarouselPlatinumPlusExclusive = ({
  user,
  customerExclusivity
}: Props) => {
  const mounted = useIsMounted();
  if (!customerExclusivity) {
    return null;
  }
  const displayExclusiveTag = (customerExclusivity.allowPlatinumToPurchase || customerExclusivity.allowWebstaurantPlusToPurchase) && !canCustomerPurchase(customerExclusivity, user);
  return <>
      {mounted && displayExclusiveTag && <div className="exclusive-tag exclusive-tag--platinum test">
          Temporarily Unavailable
        </div>}
    </>;
};
export default CarouselPlatinumPlusExclusive;